<template>
  <footer class="bg-white border-t border-gray-200">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="flex flex-col md:flex-row items-center justify-between gap-4">
        <div class="text-gray-600 text-center md:text-left">
          © 2025 Teamio. All rights reserved.
        </div>
        <div class="flex items-center space-x-6 text-gray-500">
          <RouterLink to="/about-us" class="hover:text-gray-700">About Us</RouterLink>
          <RouterLink to="/privacy-policy" class="hover:text-gray-700">Privacy Policy</RouterLink>
          <RouterLink to="/terms-of-service" class="hover:text-gray-700">Terms of Use</RouterLink>
          <RouterLink to="/contact" class="hover:text-gray-700">Contact</RouterLink>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
// No script logic needed currently
</script>